import { render, staticRenderFns } from "./DelAttrValue.vue?vue&type=template&id=77d19003&scoped=true"
import script from "./DelAttrValue.vue?vue&type=script&lang=js"
export * from "./DelAttrValue.vue?vue&type=script&lang=js"
import style0 from "./DelAttrValue.vue?vue&type=style&index=0&id=77d19003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d19003",
  null
  
)

export default component.exports